import clsx from 'clsx';
import React, { useMemo } from 'react';
import styles from './BarChart.module.scss';
export const BarChart = ({ className = '', barClassName = '', chartData })=>{
    const maxValue = useMemo(()=>Math.max(...chartData.map(({ value })=>value)), [
        chartData
    ]);
    return /*#__PURE__*/ React.createElement("div", {
        className: clsx(styles.container, className)
    }, chartData.map(({ label, value, barClassName: itemBarClassName }, idx)=>{
        const barHeight = maxValue ? value / maxValue * 100 : 0;
        return /*#__PURE__*/ React.createElement("div", {
            className: styles.barContainer,
            key: idx
        }, /*#__PURE__*/ React.createElement("div", {
            className: styles.barWrapper
        }, /*#__PURE__*/ React.createElement("div", {
            className: clsx(styles.bar, barClassName, itemBarClassName),
            style: {
                height: `${barHeight}%`
            }
        }, value ? /*#__PURE__*/ React.createElement("div", {
            className: styles.value
        }, value) : null)), /*#__PURE__*/ React.createElement("div", {
            className: styles.label
        }, label));
    }));
};
